/**
 * Commerce7 Product Details
 */

import { renderVivinoScore } from "./c7-util";

export default function C7Collection() {
	const selectors = {
		productVideo: ".c7-product-video",
		techSheet: ".c7-product-detail__tech-sheet",
		addtoCartForm: ".c7-product__variant",
		variantPrice: ".c7-product__variant__price",
        variantSelect: ".c7-product__variant__select",
        bundleContainer: ".c7-product-bundle-items",
	};

	this.init = () => {
		c7.addAction("c7_product_detail_rendered", (content) => {
			renderVideo(content);
			renderTechSheet(content);
			renderVivinoScore(content, true);
			maybeRenderBundleItems(content);
			removeVariantPrice(content);
		});
	};

	/**
	 * Remove variant price if variant select option is available.
	 */

	const removeVariantPrice = (content) => {
		content.querySelectorAll(selectors.addtoCartForm).forEach((card) => {
			if (card.querySelector(selectors.variantSelect)) {
				card.querySelector(selectors.variantPrice).remove();
			}
		});
	};

	/**
	 * Render items of the bundle
	 */
	const maybeRenderBundleItems = (content) => {
		const url = window.location.href;

		if (-1 === url.indexOf("product")) {
			return;
		}

		const slug = url.replace(/\/$/, "").split("/").slice(-1)[0];

		$.ajax({
			type: "GET",
			url: theme_object.ajax_url,
			data: { action: "get_bundle_items", slug },
			success: function (response) {
				if (response["success"]) {
					content.querySelector(selectors.bundleContainer).innerHTML = response["content"];
				}
			},
			error: function (err) {
				console.log(err);
			},
		});
	};

	/**
	 * Render video from video link.
	 */
	const renderVideo = (content) => {
		const productVideo = content.querySelector(selectors.productVideo);
		if (!productVideo) return;
		const video = parseVideo(productVideo.innerHTML);

		if (video) {
			const domString = `<div class="inner">
				<div class="c7-product-video__inner">
					<div class="c7-product-video__loading spin"></div>
					<iframe class="c7-product-video__iframe" src="${video.src}" allowfullscreen frameborder=0>
				</div>
			</div>`;
			productVideo.innerHTML = domString;
		}
	};

	/**
	 * Make downloadable link from techsheet url.
	 */
	const renderTechSheet = (content) => {
		const techSheet = content.querySelector(selectors.techSheet);
		if (techSheet) {
			const link = techSheet.innerHTML.trim();
			const domString = `<a href="${link}" class="wine-data-download" download target="_blank">
				<span class="icon-download"></span>
				<span>Download Summary</span>
			</a>`;
			techSheet.innerHTML = domString;
		}
	};

	const parseVideo = (videoLink) => {
		if (!videoLink) return false;

		const video = {
			type: "other",
			src: videoLink,
		};

		// Check if video is either vimeo or youtube.
		videoLink.match(
			/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/
		);

		if (RegExp.$3.indexOf("youtu") > -1) {
			video.type = "youtube";
			video.src = `//www.youtube.com/embed/${RegExp.$6}`;
		} else if (RegExp.$3.indexOf("vimeo") > -1) {
			video.type = "vimeo";
			video.src = `//player.vimeo.com/video/${RegExp.$6}`;
		}

		return video;
	};
}
